import { type PreviewStaticModule } from '@/lib/builder/types'

import EmailFooter from './preview/EmailFooter.vue'

export const EmailFooterStaticModule: PreviewStaticModule = {
  preview: EmailFooter,
}
